import { RootState } from '../../../common/store/store'

export const roomsStates = (state: RootState) => state.rooms
